import {
    /* Create */
    CREATE_LANDLORD_START,
    CREATE_LANDLORD_SUCCESS,
    CREATE_LANDLORD_FAILED,
    /* Fetch */
    FETCH_LANDLORD_START,
    FETCH_LANDLORD_SUCCESS,
    FETCH_LANDLORD_FAILED,
    /* Update */
    UPDATE_LANDLORD_START,
    UPDATE_LANDLORD_SUCCESS,
    UPDATE_LANDLORD_FAILED,


} from "../store/types";

const INITIAL_STATE = {
    landlords: [],
    loading: false,
    completed: false,
    success: false,
    error: {
        flag: false,
        msg: null,
    },
    currentLandlord: null,
};

let currentLandlord;
let currentLandlords;
let index;


export const landlordReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_LANDLORD_START:
            return {
                ...state,
                loading: true,
            };
        case CREATE_LANDLORD_SUCCESS:
            return {
                ...state,
                loading: false,
                completed: true,
                success: true,
                landlords: [...state.landlords, action.payload],
                currentLandlord: action.payload,
            };
        case CREATE_LANDLORD_FAILED:
            return {
                ...state,
                loading: false,
                completed: true,
                success: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case FETCH_LANDLORD_START:
            return {
                ...state,
                loading: true,
            };
        case FETCH_LANDLORD_SUCCESS:
            return {
                ...state,
                loading: false,
                completed: true,
                success: true,
                landlords: action.payload,
            };
        case FETCH_LANDLORD_FAILED:
            return {
                ...state,
                loading: false,
                completed: true,
                success: false,
                error: {
                    flag: true,
                    msg: action.payload,
                },
            };

        case UPDATE_LANDLORD_START:
            return {
                ...state,
                loading: true,
            };

        case UPDATE_LANDLORD_SUCCESS:
            currentLandlord = action.payload;
            currentLandlords = state.landlords;
            index = currentLandlords.findIndex((listing) => listing.id === currentLandlord.id);

            if (index !== -1) {

                currentLandlords[index] = currentLandlord;

                return {
                    ...state,
                    loading: false,
                    completed: true,
                    success: true,
                    landlords: [...currentLandlords],
                    currentLandlord: action.payload,
                };

            }



        default:
            return state;

    }
};
